import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import ResponseTimeInfo from 'components/response-time-info/ResponseTimeInfo';

import InfluencerModalActions from 'modules/influencers/components/modals/modal-actions/InfluencerModalActions';
import TileStandardContext from '../context/TileStandardContext';
import TileStandardFooterDelete from './delete/TileStandardFooterDelete';
import TileStandardFooterHistoryButton from './history/TileStandardFooterHistoryButton';

import { isLightweightProfileMaintainerSelector } from 'selectors/lightWeightProfileMaintainers';

import './tile-standard-footer.scss';

import type {
  ListContextMenu,
  ResponseTime,
  TileStandard,
  TileStandardType
} from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  creator: TileStandard,
  tileType: TileStandardType,
  isHidden: boolean,
  contextMenuProps?: ListContextMenu,
  onDelete?: (a: TileStandard) => void
};

type StateProps = {
  isHistoryAvailable: boolean,
  isLightweightProfileMaintainer: boolean,
  responseTime: ResponseTime | undefined | null
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by connect, so we should keep it here
} & OwnProps & StateProps;

const TileStandardFooter = ({
  creator,
  tileType,
  isHidden,
  isHistoryAvailable,
  isLightweightProfileMaintainer,
  responseTime,
  contextMenuProps,
  onDelete
}: Props): JSX.Element => {
  const content = React.useContext(TileStandardContext);

  const containerClasses = classnames('tile-standard-footer', {
    'tile-standard-footer--is-hidden': isHidden
  });

  return (
    <div className={containerClasses}>
      {
        isHistoryAvailable && (
          <div className="tile-standard-footer__section">
            <TileStandardFooterHistoryButton
              creator={creator}
            />
          </div>
        )
      }
      {
        tileType === 'lists' && (
          <div className="tile-standard-footer__section">
            <ResponseTimeInfo
              creatorProfile={creator}
              responseTime={responseTime}
            />
          </div>
        )
      }
      {
        isLightweightProfileMaintainer && creator.isLightweight && !onDelete && (
          <div className="tile-standard-footer__section">
            <TileStandardFooterDelete
              creator={creator}
            />
          </div>
        )
      }
      <div className="tile-standard-footer__icons">
        <div className="tile-standard-footer__actions">
          <InfluencerModalActions
            influencer={creator}
            contextMenuProps={contextMenuProps}
            isFreemium={content?.isFreemium}
            onDelete={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, { creator }): StateProps => ({
  isHistoryAvailable: state.lists.historyAvailability[creator.id],
  isLightweightProfileMaintainer: isLightweightProfileMaintainerSelector(state),
  responseTime: state.influencerResponseTime.responseTimeData[creator.id]
});

export default connect(mapStateToProps)(TileStandardFooter);
